export const ImportHeader = () => {
  return (
    <>
      <div className="text-2xl font-bold leading-9">Bulk upload cases from a file</div>
      <div className="my-6 h-[1px] w-full bg-border" />
    </>
  )
}
